import {
  Link,
  Coffee,
  Globe,
  Phone,
  Mail,
  MapPin,
  ShoppingCart,
  Music,
  Video,
  Calendar,
  Star,
  Heart,
  Bookmark,
  Camera,
  Image,
  Mic,
  Headphones,
  Gamepad2,
  BookOpen,
  Newspaper,
  Rss,
  Youtube,
  Linkedin,
  Github,
  Twitch,
  Store,
  Briefcase,
  Home,
  Building,
  Utensils,
  Pizza,
  Sandwich,
  IceCream,
  Beer,
  Wine,
  ShoppingBag,
  Gift,
  Ticket,
  Tag,
  Award,
  Trophy,
  Zap,
  Flame,
  Leaf,
  Sun,
  Moon,
  Cloud,
  Umbrella,
  Car,
  Bus,
  Train,
  Bike,
  Plane,
  Ship,
  Anchor,
  Compass,
  Map,
  Navigation,
  type LucideIcon,
} from "lucide-react"
import {
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  TikTokIcon,
  WhatsAppIcon,
  GoogleIcon,
} from "./Icons"
import { detectPlatform } from "../utils/linkPlatform"

const LUCIDE_ICONS: Record<string, LucideIcon> = {
  link: Link,
  coffee: Coffee,
  globe: Globe,
  phone: Phone,
  mail: Mail,
  "map-pin": MapPin,
  "shopping-cart": ShoppingCart,
  music: Music,
  video: Video,
  calendar: Calendar,
  star: Star,
  heart: Heart,
  bookmark: Bookmark,
  camera: Camera,
  image: Image,
  mic: Mic,
  headphones: Headphones,
  gamepad: Gamepad2,
  book: BookOpen,
  newspaper: Newspaper,
  rss: Rss,
  youtube: Youtube,
  linkedin: Linkedin,
  github: Github,
  twitch: Twitch,
  store: Store,
  briefcase: Briefcase,
  home: Home,
  building: Building,
  utensils: Utensils,
  pizza: Pizza,
  sandwich: Sandwich,
  "ice-cream": IceCream,
  beer: Beer,
  wine: Wine,
  "shopping-bag": ShoppingBag,
  gift: Gift,
  ticket: Ticket,
  tag: Tag,
  award: Award,
  trophy: Trophy,
  zap: Zap,
  flame: Flame,
  leaf: Leaf,
  sun: Sun,
  moon: Moon,
  cloud: Cloud,
  umbrella: Umbrella,
  car: Car,
  bus: Bus,
  train: Train,
  bike: Bike,
  plane: Plane,
  ship: Ship,
  anchor: Anchor,
  compass: Compass,
  map: Map,
  navigation: Navigation,
}

interface LinkThumbnailProps {
  url: string
  label?: string
  iconName?: string | null
  iconSvg?: string | null
  thumbnailUrl?: string | null
  className?: string
  imgClassName?: string
}

export function LinkThumbnail({
  url,
  label,
  iconName,
  iconSvg,
  thumbnailUrl,
  className = "h-5 w-5",
  imgClassName,
}: LinkThumbnailProps) {
  if (thumbnailUrl) {
    return (
      <img
        src={thumbnailUrl}
        alt={label || ""}
        className={imgClassName || `${className} rounded object-cover`}
        onError={(e) => {
          ;(e.target as HTMLImageElement).style.display = "none"
        }}
      />
    )
  }

  // Tabler icons: trusted SVG seeded server-side, rendered inline (zero icon-lib JS).
  if (iconSvg) {
    return (
      <span
        className={`${className} block [&>svg]:h-full [&>svg]:w-full`}
        dangerouslySetInnerHTML={{ __html: iconSvg }}
      />
    )
  }

  if (iconName && LUCIDE_ICONS[iconName]) {
    const Icon = LUCIDE_ICONS[iconName]
    return <Icon className={className} />
  }

  const platform = detectPlatform(url, label)
  switch (platform) {
    case "instagram":
      return <InstagramIcon className={className} />
    case "facebook":
      return <FacebookIcon className={className} />
    case "twitter":
      return <TwitterIcon className={className} />
    case "tiktok":
      return <TikTokIcon className={className} />
    case "whatsapp":
      return <WhatsAppIcon className={className} />
    case "google":
      return <GoogleIcon className={className} />
    default:
      return null
  }
}

export { LUCIDE_ICONS }
